import { NavLink, Outlet, Link } from 'react-router-dom';

import { useSession } from '../hooks/useSession';
import { shortAddress } from '../lib/format';

export function Layout() {
  const { profile, signOut } = useSession();

  return (
    <div className="shell">
      <header className="topbar">
        <Link to="/" className="brand">
          <span className="brand-mark">◆</span>Ithildin
        </Link>

        {profile && (
          <nav className="row" style={{ gap: 20 }}>
            <NavLink to="/inbox" className="nav-link">Inbox</NavLink>
            <NavLink to="/compose" className="nav-link">Compose</NavLink>
            <NavLink to="/settings" className="nav-link">Settings</NavLink>
          </nav>
        )}

        <div className="spacer" />

        {profile && (
          <div className="row" style={{ gap: 12 }}>
            <span className="addr" title={profile.address}>
              {shortAddress(profile.address, 4, 4)}
            </span>
            <button className="btn btn-quiet btn-sm" onClick={() => void signOut()}>
              Sign out
            </button>
          </div>
        )}
      </header>

      <main style={{ flex: 1 }}>
        <Outlet />
      </main>
    </div>
  );
}
